module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_20.53bdfa86.jpg";